/* components/SiteHeader.ts
Global Site Header

Example
<site-header>
    Site header content here
</site-header>
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { CartMain } from '../Cart/CartMain';

@Component
export class SiteHeader extends ThemeComponent {
    @Ref() row!: HTMLDivElement;
    @Ref() cartTrigger!: HTMLDivElement;

    init() {
        this.handleBodyPadding();
        this.cartEvent();
    }

    /**
     * Handle Body Padding.
     */
    private handleBodyPadding() {
        const height = this.row.offsetHeight;
        document.body.style.paddingTop = `${height}px`;
    }

    /**
     * Cart Close click event.
     * @returns
     */
    cartEvent() {
        this.$listen(this.cartTrigger, 'click', (event) => {
            event.preventDefault();
            document.dispatchEvent(new Event('cartOpen'));
        });
    }
}
